module.exports = __webpack_public_path__ + "static/img/storage4.1bd73e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storage4.png
// module id = 7vYM
// module chunks = 2